<cdk-virtual-scroll-viewport class="comment-list-viewport" itemSize="120" minBufferPx="200" maxBufferPx="400">
  <div class="comment-list">
    <div class="comment-item-wrapper" *cdkVirtualFor="let comment of comments; trackBy: trackByCommentId">
      <ptl-comment-item
        [comment]="comment"
        [momentId]="momentId"
        [isTopLevel]="true"
        [currentUserId]="currentUserId"
        (commentUpdated)="onCommentUpdated($event)"
        (commentDeleted)="onCommentDeleted($event)"
        (commentLiked)="onCommentLiked($event.commentId, $event.isLiked)"
        (replyCreated)="onReplyCreated($event.reply, $event.parentCommentId)"
      >
      </ptl-comment-item>
    </div>
  </div>
</cdk-virtual-scroll-viewport>
